<div
  infinite-scroll
  [infiniteScrollDistance]="1"
  [infiniteScrollThrottle]="50"
  [infiniteScrollDisabled]="maxReached"
  (scrolled)="scrolled.emit()"
>
  <ng-content></ng-content>
  <div *ngIf="loading" class="cx-spinner">
    <eb-spinner></eb-spinner>
  </div>
</div>
